// Get Locations Use Case

import {InventoryRepository} from '../repository/InventoryRepository';
import {Location} from '../models/inventory.model';

export class GetLocationsUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (): Promise<Location[]> {
    try {
      const locations = await this.inventoryRepository.getAllLocations();

      // Business Logic: Filter only active locations
      const activeLocations = locations.filter(location => location.isActive);

      return activeLocations;
    } catch (error) {
      throw error;
    }
  }
}
